import { render, staticRenderFns } from "./user-connected-request-popup.html?vue&type=template&id=4faa9373&scoped=true&external"
import script from "./user-connected-request-popup.js?vue&type=script&lang=js&external"
export * from "./user-connected-request-popup.js?vue&type=script&lang=js&external"
import style0 from "./user-connected-request-popup.scss?vue&type=style&index=0&id=4faa9373&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa9373",
  null
  
)

export default component.exports